export enum ImpressionDynamicsDatasetEnum {
    MainPeriod = 'main_period',
    ComparePeriod = 'compare_period',
}
